export default {
  ALARM: 34,
  ANALYSIS: 19,
  ANLAGEN_INFO: 32,
  BATTERY_OVERVIEW: 80,
  POWER_FLOW: 79,
  CALENDAR_ITEMS: 59,
  CALENDAR: 27,
  CHART_STATIC: 25,
  CURRENT_SYSTEM_DATA: 46,
  CHART: 5,
  COMPONENT_REPLACEMENT: 39,
  DOCUMENTS: 18,
  DOCUMENTS_TREE: 22,
  ENVIRONMENTAL_SAVINGS: 66,
  FEED: 10,
  IFRAME: 61,
  INCIDENTS: 71,
  INVERTER_EVALUATION: 36,
  INVERTER_EVALUATION_CHART: 37,
  MAP: 11,
  PARK_CHARTS: 42,
  AC_POWER: 37,
  MONITORING_STATUS: 8,
  PERFORMANCE_OVERVIEW: 35,
  PUBLIC_TICKET_LIST: 47,
  REPORT_HISTORY: 45,
  REPORT_TEMPLATES: 14,
  REGULAR_EVENTS: 75,
  SCHEMAGRAPH: 7,
  SCHEMA_TABLE: 4,
  SIMPLE_ALARM_VIEW: 67,
  SOLAR_ACCOUNT: 68,
  SYSLOG: 15,
  SYSTEM_ACCESS_CONTROL: 76,
  SYSTEM_DATA_LOGGER: 49,
  SYSTEM_DIAGRAM: 25,
  SYSTEM_INFORMATION: 32,
  SYSTEM_PERFORMANCE: 44,
  SYSTEM_PROFILE: 43,
  SYSTEM_STATUS: 46,
  SYSTEM_VISUALIZATION: 7,
  SYSTEM_YIELD_FORECAST: 48,
  TAB_MANAGER: 50,
  TECHNICAL_DATA: 28,
  TICKET: 29,
  TICKETS: 78,
  TICKET_OVERVIEW: 12,
  TICKET_STATISTICS: 62,
  YIELD_FORECAST: 48,
  WEBCAM: 60,
  WORK_ORDER_OVERVIEW: 73,
  ALARMS: 77,
  MEASUREMENT_DATA_API: 81,
  CONTROL_STATUS: 82,
  CONTROL_INDICATORS: 84,
  DIGITAL_SIGNALS: 85,
  DEVICE_EVENTS: 86,
};
